"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.default = exports.HelperText = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const propTypes = {
  prefix: _propTypes.string,
  className: _propTypes.string,
  children: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.node), _propTypes.node]),
  id: _propTypes.string,
  shouldValidate: _propTypes.bool,
  valid: _propTypes.bool,
  textOnly: _propTypes.bool
};
exports.propTypes = propTypes;
const HelperText = props => {
  const {
    prefix = '',
    children,
    className,
    shouldValidate,
    valid,
    textOnly = false,
    ...otherProps
  } = props;
  const baseClass = "".concat(prefix, "helper-text");
  const cssStyles = (0, _classnames.default)(baseClass, shouldValidate && "".concat(baseClass, "--").concat(valid ? 'success' : 'error'), textOnly && "".concat(baseClass, "--text-only"), className);
  return _react.default.createElement("span", _extends({}, otherProps, {
    className: cssStyles
  }), children);
};
exports.HelperText = HelperText;
HelperText.displayName = 'HelperText';
var _default = HelperText;
exports.default = _default;